import api from 'api';
import { DropzoneFile } from 'components/Dropzone/utils';
import { DropzoneUpload, DropzoneDelete } from 'models/Dropzone';
import { useCallback } from 'react';

export const LISTING_IM = 'listingIM';

const useUploadIm = (
  dealRoomId: string,
  updateListingIm?: (listingIm: DropzoneFile) => void,
) => {
  const uploadListingIm: DropzoneUpload = useCallback(
    async (file, _, config) => {
      const { uploadedFile, dealRoom } = await api.dealRoom.uploadDealFile(
        file,
        LISTING_IM,
        dealRoomId,
        config,
      );

      const updated = { ...uploadedFile, id: dealRoom?.listingIM?._id };

      updateListingIm?.(updated);

      return updated;
    },
    [dealRoomId, updateListingIm],
  );

  const deleteListingIm: DropzoneDelete = useCallback(
    async (file) => {
      const {
        data: { fileId },
      } = await api.dealRoom.deleteDealFile(LISTING_IM, file.id, dealRoomId);

      updateListingIm?.(null);
      return fileId;
    },
    [dealRoomId, updateListingIm],
  );

  return {
    uploadListingIm,
    deleteListingIm,
  };
};

export default useUploadIm;
